<template>
  <StatusBadge :variant="config.bg">
    {{ config.label }}
  </StatusBadge>
</template>

<script>
import {License} from "@/models/License";
import StatusBadge from "@/components/common/StatusBadge.vue";

export default {
  components: {StatusBadge},
  props: {
    license: License,
    inverted: Boolean
  },
  computed: {
    config() {
      const status = this.license.statusWithConfig;
      if (status) {
        return {
          bg: status.type === 'active' ? 'success' : status.type === 'pending' ? 'danger' : 'dark',
          text: 'white',
          label: status.label
        };
      } else {
        return {
          bg: 'dark',
          text: 'white',
          label: `Unknown: ${this.license.status}`
        };
      }
    }
  }
}
</script>

<style scoped>
.status-inverted {
  padding-left: 0!important;
  padding-right: 0!important;

}
</style>
